import { memo, useMemo } from 'react';

import { usePhotoSwipeLightbox } from '../../../../../../hooks/use-photo-swipe-lightbox';
import imgLite from '../../images/detail/version-summary-lite.png';
import imgPro from '../../images/detail/version-summary-pro.png';
import imgStandard from '../../images/detail/version-summary-standard.png';

import './version-compare-image-list.scss';

const id = 'version-compare-image-list';

export const VersionCompareImageList: React.FC = memo(() => {
  usePhotoSwipeLightbox(id);

  const images = useMemo(() => {
    return [
      {
        url: imgLite,
      },
      {
        url: imgStandard,
      },
      {
        url: imgPro,
      },
    ].map((item) => ({
      ...item,
      width: 750,
      height: 780,
    }));
  }, []);

  return (
    <div id={id}>
      {images.map((image, index) => (
        <img
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className="previewable"
          styleName="img"
          draggable={false}
          src={image.url}
          alt=""
          data-pswp-src={image.url}
          data-pswp-width={image.width}
          data-pswp-height={image.height}
        />
      ))}
    </div>
  );
});
